import { render, staticRenderFns } from "./SliderCard.vue?vue&type=template&id=6531f126&scoped=true"
import script from "./SliderCard.vue?vue&type=script&lang=js"
export * from "./SliderCard.vue?vue&type=script&lang=js"
import style0 from "./SliderCard.vue?vue&type=style&index=0&id=6531f126&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6531f126",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6531f126')) {
      api.createRecord('6531f126', component.options)
    } else {
      api.reload('6531f126', component.options)
    }
    module.hot.accept("./SliderCard.vue?vue&type=template&id=6531f126&scoped=true", function () {
      api.rerender('6531f126', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/cards/SliderCard.vue"
export default component.exports